import React from 'react'
import Button from '@material-ui/core/Button'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import {NavButtonWithSize} from 'Event/Dashboard/components/NavButton'
import {generateHashId} from 'lib/crypto/hash'
import {useAddTranslation} from 'Event/LanguageProvider'
import {useTemplate} from 'Event/TemplateProvider'
import {BaseTemplate} from 'Event/template'

export default function AddBlogPostButtonButton(props: {
  postId: string
  onAdd?: (button: NavButtonWithSize) => void
  postFormStyles?: BaseTemplate['postFormStyles']
}) {
  const {postId, onAdd} = props
  const update = useSaveTemplate()
  const addTranslation = useAddTranslation()
  const template = useTemplate()

  const add = () => {
    const newButton: NavButtonWithSize = {
      text: 'Button',
      link: '',
      size: 12,
      rules: [],
      isAreaButton: false,
      isImageUpload: false,
      isFormButton: false,
      isCertificateButton: false,
      areaId: null,
      formId: null,
      certificateId: null,
      actionId: null,
      isVisible: true,
      infusionsoftTag: null,
      mailchimpTag: null,
      hubspotTag: null,
      hubspotV2Tag: null,
      activeCampaignTag: null,
      convertKitTag: null,
      ontraportTag: null,
      clickFunnelsTag: null,
      zapierTag: null,
      highLevelTag: null,
      image: '',
      webhook: null,
      padding: 8,
      font:
        props.postFormStyles?.buttonFont ?? template.postFormStyles.buttonFont,
      fontSize:
        props.postFormStyles?.buttonFontSize ??
        template.postFormStyles.buttonFontSize,
      height:
        props.postFormStyles?.buttonHeight ??
        template.postFormStyles.buttonHeight ??
        undefined,
      backgroundColor:
        props.postFormStyles?.buttonBackgroundColor ??
        template.postFormStyles.buttonBackgroundColor,
      hoverBackgroundColor:
        props.postFormStyles?.buttonHoverBackgroundColor ??
        template.postFormStyles.buttonHoverBackgroundColor,
      textColor:
        props.postFormStyles?.buttonColor ??
        template.postFormStyles.buttonColor,
      hoverTextColor:
        props.postFormStyles?.buttonHoverTextColor ??
        template.postFormStyles.buttonHoverTextColor ??
        undefined,
      disableHover:
        props.postFormStyles?.buttonDisableHover ??
        template.postFormStyles.buttonDisableHover,
      borderRadius:
        props.postFormStyles?.buttonRadius ??
        template.postFormStyles.buttonRadius,
      borderWidth:
        props.postFormStyles?.buttonBorderWidth ??
        template.postFormStyles.buttonBorderWidth,
      borderColor:
        props.postFormStyles?.buttonBorderColor ??
        template.postFormStyles.buttonBorderColor,
      hoverBorderColor:
        props.postFormStyles?.buttonHoverBorderColor ??
        template.postFormStyles.buttonHoverBorderColor ??
        undefined,
    }

    if (onAdd) {
      onAdd(newButton)
      return
    }

    generateHashId([
      'blogpost_button',
      new Date().valueOf().toString(),
      Math.random().toString(),
    ]).then((id) => {
      const componentId = `blogpost_button_${id}`
      update({
        blogPosts: {
          [postId]: {
            buttons: {
              [componentId]: {...newButton, text: `{{${componentId}_text}}`},
            },
          },
        },
        localization: addTranslation({
          [`${componentId}_text`]: 'Button',
        }),
      })
    })
  }

  return (
    <Button
      color="primary"
      aria-label="add new button"
      onClick={add}
      variant="outlined"
      fullWidth
    >
      Add Button
    </Button>
  )
}
